import { IFilter, IFilterElement } from "@saleor/components/Filter";
import {
  CouponRedemptionListUrlFilters,
  CouponRedemptionListUrlFiltersEnum,
  CouponsRedemptionListUrlFilterWithMultipleValues
} from "@saleor/coupons/url";
import { FilterOpts, MinMax } from "@saleor/types";
import { CouponRedemptionStatusEnum } from "@saleor/types/globalTypes";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import {
  getMinMaxQueryParam,
  getMultipleEnumValueQueryParam
} from "@saleor/utils/filters/filters";
import { defineMessages, IntlShape } from "react-intl";

export enum CouponRedemptionFilterKeys {
  status = "status",
  dateRange = "dateRange"
}

export interface CouponRedemptionListUrlFilterOpts {
  status: FilterOpts<CouponRedemptionStatusEnum[]>;
  dateRange: FilterOpts<MinMax>;
}

const messages = defineMessages({
  claimed: {
    defaultMessage: "Claimed",
    description: "Claimed Coupon"
  },
  dateRange: {
    defaultMessage: "Date Range",
    description: "Date Range"
  },
  redeemed: {
    defaultMessage: "Redeemed",
    description: "Redeemed Coupon"
  },
  status: {
    defaultMessage: "Status",
    description: "Coupon Status"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CouponRedemptionListUrlFilterOpts
): IFilter<CouponRedemptionFilterKeys> {
  return [
    {
      ...createOptionsField(
        CouponRedemptionFilterKeys.status,
        intl.formatMessage(messages.status),
        opts.status.value,
        true,
        [
          {
            label: intl.formatMessage(messages.claimed),
            value: CouponRedemptionStatusEnum.CLAIMED
          },
          {
            label: intl.formatMessage(messages.redeemed),
            value: CouponRedemptionStatusEnum.REDEEMED
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createDateField(
        CouponRedemptionFilterKeys.dateRange,
        intl.formatMessage(messages.dateRange),
        opts.dateRange.value
      ),
      active: opts.dateRange.active
    }
  ];
}

export function getFilterQueryParam(
  filter: IFilterElement<CouponRedemptionFilterKeys>
): CouponRedemptionListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CouponRedemptionFilterKeys.status:
      return getMultipleEnumValueQueryParam(
        filter,
        CouponsRedemptionListUrlFilterWithMultipleValues.status,
        CouponRedemptionStatusEnum
      );

    case CouponRedemptionFilterKeys.dateRange:
      return getMinMaxQueryParam(
        filter,
        CouponRedemptionListUrlFiltersEnum.claimedDate,
        CouponRedemptionListUrlFiltersEnum.redeemedDate
      );
  }
}
